import { Box } from '@bpba/ui-components';
import { FC } from 'react';
import { Spinner } from './Spinner';

export const LoadingComponent: FC = () => {
  return (
    <Box marginY={['50px', '100px', '150px']}>
      <Spinner />
    </Box>
  );
};